import { useEffect, useState } from 'react'
import { quarterTimeRemaining } from '../lib/dateUtils.js'

export default function CountdownTimer({ compact = false, dark = false }) {
  const [time, setTime] = useState(quarterTimeRemaining())

  useEffect(() => {
    const id = setInterval(() => setTime(quarterTimeRemaining()), 60_000)
    return () => clearInterval(id)
  }, [])

  if (time.ended) {
    return <span className={dark ? 'text-white/70 text-xs' : 'text-brand-text-muted text-xs'}>Q2 2026 closed</span>
  }

  const labelCls = dark ? 'text-white/60' : 'text-brand-text-muted'
  const valueCls = dark ? 'text-white' : 'text-brand-text'

  if (compact) {
    return (
      <span className={`text-xs ${labelCls}`}>
        <span className={`font-semibold ${valueCls}`}>{time.days}</span>d <span className={`font-semibold ${valueCls}`}>{time.hours}</span>h left
      </span>
    )
  }

  return (
    <div className="flex items-center gap-1.5 text-xs">
      <span className={labelCls}>Quarter ends in</span>
      <span className={`font-semibold ${valueCls}`}>{time.days}d</span>
      <span className={`font-semibold ${valueCls}`}>{time.hours}h</span>
      <span className={`font-semibold ${valueCls}`}>{time.minutes}m</span>
    </div>
  )
}
